module.exports = __webpack_public_path__ + "img/bg_court_06.79d9e361.jpg";